const CITIES = [
    { name: "Sertã — Sede", x: 205, y: 300, hq: true },
    { name: "Lisboa", x: 158, y: 345 },
    { name: "Madrid", x: 420, y: 275 },
    { name: "Barcelona", x: 615, y: 175 },
    { name: "Sevilha", x: 330, y: 445 },
];

const ROUTES = [
    "M205,300 L420,275",
    "M205,300 L330,445",
    "M205,300 L615,175",
];

export const IberiaMap = () => (
    <svg
        viewBox="0 0 800 620"
        className="h-auto w-full"
        role="img"
        aria-label="Mapa estilizado de Portugal e Espanha"
        data-testid="iberia-map"
    >
        <path
            d="M180,80 L250,58 L335,68 L425,52 L525,72 L605,108 L645,168 L622,238 L645,300 L602,382 L560,452 L498,502 L418,522 L338,500 L298,438 L278,378 L258,298 L218,218 L188,148 Z"
            fill="#141417"
            stroke="rgba(255,255,255,0.16)"
            strokeWidth="1.5"
        />
        <path
            d="M180,80 L232,92 L242,162 L236,242 L246,322 L236,402 L214,462 L184,430 L168,338 L158,238 L164,148 Z"
            fill="#1C1C20"
            stroke="#E63946"
            strokeWidth="2"
        />
        {ROUTES.map((d, i) => (
            <path
                key={i}
                d={d}
                fill="none"
                stroke="#E63946"
                strokeWidth="1.5"
                strokeDasharray="6 8"
                opacity="0.55"
            />
        ))}
        {CITIES.map((c) => (
            <g key={c.name}>
                <circle cx={c.x} cy={c.y} r="7" fill={c.hq ? "#E63946" : "#F4A261"} opacity="0.35" className="map-pulse" />
                <circle cx={c.x} cy={c.y} r={c.hq ? 6 : 4} fill={c.hq ? "#E63946" : "#F4A261"} />
                <text
                    x={c.x + 14}
                    y={c.y + 4}
                    fill={c.hq ? "#FFFFFF" : "#A1A1AA"}
                    fontSize="13"
                    fontFamily="JetBrains Mono, monospace"
                    letterSpacing="1"
                >
                    {c.name.toUpperCase()}
                </text>
            </g>
        ))}
        <text x="430" y="590" fill="#52525B" fontSize="12" fontFamily="JetBrains Mono, monospace" letterSpacing="4">
            ESPANHA
        </text>
        <text x="120" y="520" fill="#E63946" fontSize="12" fontFamily="JetBrains Mono, monospace" letterSpacing="4">
            PORTUGAL
        </text>
    </svg>
);
